export function normalizeSubscriptionToken(token) {
  if (typeof token !== 'string') {
    return '';
  }
  return token.trim().toLowerCase();
}

export function resolveSubscriptionToken(token, subscriptionInfo = {}) {
  const normalized = normalizeSubscriptionToken(token);
  if (!normalized) {
    return undefined;
  }

  const info = subscriptionInfo || {};
  const accountId = typeof info.accountId === 'string' ? info.accountId : '';
  const name = typeof info.name === 'string' ? info.name : '';

  if (normalized === 'tdfaccountid' || normalized === 'tdf_account_id') {
    return accountId || undefined;
  }

  if (
    normalized === 'subscriptionname' ||
    normalized === 'subscription_name' ||
    normalized === 'subscriptionid' ||
    normalized === 'subscription_id'
  ) {
    return name || undefined;
  }

  return undefined;
}
